interface ToastProps {
  message: string | null;
  tone: "success" | "error";
  onDismiss: () => void;
}

export function Toast({ message, tone, onDismiss }: ToastProps) {
  if (message === null) return null;
  return (
    <div className={`toast ${tone}`} role={tone === "error" ? "alert" : "status"}>
      <span aria-hidden="true">{tone === "error" ? "!" : "✓"}</span>
      <p>{message}</p>
      <button type="button" onClick={onDismiss} aria-label="Đóng thông báo">×</button>
    </div>
  );
}

export function LoadingPage() {
  return (
    <main className="loading-page" aria-label="Đang tải">
      <span className="loading-logo">▶</span>
      <div className="spinner" />
      <p>Đang kết nối KidTube Cloud…</p>
    </main>
  );
}

interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
  action?: { label: string; onClick: () => void };
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <span className="empty-icon" aria-hidden="true">{icon}</span>
      <h3>{title}</h3>
      <p>{description}</p>
      {action !== undefined && (
        <button type="button" className="secondary-button" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
